import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number = 15) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: initialMinutes,
    seconds: 0,
  })
  const [isUrgent, setIsUrgent] = useState(false)

  useEffect(() => {
    const storageKey = 'manual_countdown_end'
    const savedEndTime = localStorage.getItem(storageKey)
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
      if (endTime < Date.now()) {
        endTime = Date.now() + initialMinutes * 60 * 1000
        localStorage.setItem(storageKey, endTime.toString())
      }
    } else {
      endTime = Date.now() + initialMinutes * 60 * 1000
      localStorage.setItem(storageKey, endTime.toString())
    }

    const calculateTimeLeft = () => {
      const difference = endTime - Date.now()

      if (difference > 0) {
        const h = Math.floor(difference / (1000 * 60 * 60))
        const m = Math.floor((difference / 1000 / 60) % 60)
        const s = Math.floor((difference / 1000) % 60)
        setTimeLeft({ hours: h, minutes: m, seconds: s })
        // Urgent when 5 minutes or less remain
        setIsUrgent(difference <= 5 * 60 * 1000)
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
        setIsUrgent(true)
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [initialMinutes])

  return { ...timeLeft, isUrgent }
}
